import React from 'react';
import ButtonBarForPatientSummary, { ButtonBarChartOrTable } from '../Navbar/ButtonBarForPatientSummary';
import {
  Checkbox,
  FormGroup,
  FormControlLabel,
  Typography,
  // Chip
} from '@material-ui/core';
import CalendarDateRange from '../DatePicker/CalendarDateRange';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { observer, inject } from 'mobx-react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import Paper from '@material-ui/core/Paper';
import { AutoSizer, Column, Table } from 'react-virtualized';

const PatientSummaryAlert = (props) => {
  const t = props.t;
  const store = props.patientsummaryalert;
  const chartType = store.chartType;
  const dateRange = store.dateRange;
  const monthlySetting = store.monthlySetting;
  const dailySetting = store.dailySetting;
  const onDownloadCsv = store.downloadCsv;

  const onMonthlySettingChange = (key, checked) => {
    store.setMonthlySetting(key, checked);
  };
  const onDailySettingChange = (key, checked) => {
    store.setDailySetting(key, checked);
  };

  const onChartTypeChanged = (chartType) => {
    store.setChartType(chartType);
  };

  const onStartDateChange = (date) => {
    store.getPatientSummaryAlertReload(date, null);
  };

  const onEndDateChange = (date) => {
    store.getPatientSummaryAlertReload(null, date);
    props.onEndDateChange(date);
  };

  const onIsShowTableChangedForMonthly = (isShowTableView) => {
    store.setMonthlySetting('isShowTableView', isShowTableView);
  };

  return (
    <div className='flex-wrap flex-auto min-w-0 px-16 mb-16'>
      <div className='relative flex-col flex-wrap block col-span-12 mx-3 my-4 bg-white rounded shadow-lg'>
        <PatientSummaryAlertTopControlPanel
          t={t}
          chartType={chartType}
          onChartTypeChanged={onChartTypeChanged}
          dateRange={dateRange}
          onStartDateChange={onStartDateChange}
          onEndDateChange={onEndDateChange}
          monthlySetting={monthlySetting}
          dailySetting={dailySetting}
          onMonthlySettingChange={onMonthlySettingChange}
          onDailySettingChange={onDailySettingChange}
          onIsShowTableChangedForMonthly={onIsShowTableChangedForMonthly}
          onDownloadCsv={onDownloadCsv}
        />
        <ChartsContainer
          store={store}
          t={t}
          chartType={chartType}
          summaryAlertMonthly={store.summaryAlertMonthly}
          dateRange={dateRange}
          dailySetting={dailySetting}
          monthlySetting={monthlySetting}
        />
      </div>
    </div>
  );
};

const ChartsContainer = (props) => {
  const chartType = props.chartType;
  const store = props.store;
  const dateRange = props.dateRange;
  const dailySetting = props.dailySetting;
  const monthlySetting = props.monthlySetting;
  const t = props.t;

  const monthlyView = monthlySetting.isShowTableView ? (
    <TableContainerMonthly store={store} t={t} monthlySetting={monthlySetting} dateRange={dateRange} />
  ) : (
    <ChartsContainerMonthly store={store} t={t} monthlySetting={monthlySetting} dateRange={dateRange} />
  );

  return (
    <div className='px-6 pb-5'>
      {chartType === 'monthly' ? (
        monthlyView
      ) : (
        <ChartsContainerDaily store={store} t={t} dailySetting={dailySetting} dateRange={dateRange} />
      )}
    </div>
  );
};

const ChartsContainerDaily = (props) => {
  const t = props.t;
  const store = props.store;
  const dateRange = props.dateRange;
  const dailySetting = props.dailySetting;

  return (
    <div className='flex-wrap block xl:flex'>
      {dailySetting.isShowAlert && (
        //<div className="w-full p-4 pt-1">
        //  <ChartSummaryAlertDaily title={"จำนวนการแจ้งเตือนทั้งหมด"} dateRange={dateRange} summaryAlertDailyData={store.toJS().summaryAlertDaily} alertTypeInfos={store.toJS().alertTypeInfos} />
        //</div>
        <div className='w-full p-4 pt-1'>
          <ChartSummaryAlertDailyAllMonths
            t={t}
            dateRange={dateRange}
            summaryAlertDailyData={store.toJS().summaryAlertDaily}
            alertTypeInfos={store.toJS().alertTypeInfos}
          />
        </div>
      )}
      {dailySetting.isShowUsage && (
        <div className='w-full p-4 pt-1'>
          <ChartSummaryUsageDaily
            t={t}
            title={t('patient_summary_total_usage_time')}
            dateRange={dateRange}
            summaryUsageData={store.toJS().summaryUsage}
          />
        </div>
      )}
    </div>
  );
};

const TableContainerMonthly = (props) => {
  const t = props.t;
  const store = props.store;
  const dateRange = props.dateRange;
  const monthlySetting = props.monthlySetting;

  return (
    <div className='flex-wrap block xl:flex'>
      {monthlySetting.isShowAlert && (
        <div className='w-full p-4 pt-1'>
          <WrappedTableSummaryAlertMonthly
            t={t}
            title={t('patient_summary_total_number_of_notifications')}
            dateRange={dateRange}
            summaryAlertMonthlyData={store.summaryAlertMonthly}
            alertTypeInfos={store.toJS().alertTypeInfos}
          />
        </div>
      )}
      {monthlySetting.isShowNoOfAlert && (
        <div className='w-full p-4 pt-1'>
          <WrappedTableSummaryNoOfDayForEachAlertMonthly
            t={t}
            title={t('patient_summary_number_of_days_with_notifications')}
            dateRange={dateRange}
            summaryAlertMonthlyData={store.summaryAlertMonthly}
            alertTypeInfos={store.toJS().alertTypeInfos}
          />
        </div>
      )}
      {monthlySetting.isShowAvgAlertPerDay && (
        <div className='w-full p-4 pt-1'>
          <WrappedTableSummaryAlertAvgMonthly
            t={t}
            title={t('patient_summary_average_number_of_notifications_per_day')}
            dateRange={dateRange}
            summaryAlertMonthlyData={store.summaryAlertMonthly}
            alertTypeInfos={store.toJS().alertTypeInfos}
          />
        </div>
      )}
    </div>
  );
};

const ChartsContainerMonthly = (props) => {
  const t = props.t;
  const store = props.store;
  const dateRange = props.dateRange;
  const monthlySetting = props.monthlySetting;

  return (
    <div className='flex-wrap block xl:flex'>
      {monthlySetting.isShowAlert && (
        <div className='w-full p-4 pt-1'>
          <ChartSummaryAlertMonthly
            t={t}
            title={t('patient_summary_total_number_of_notifications')}
            dateRange={dateRange}
            summaryAlertMonthlyData={store.summaryAlertMonthly}
            alertTypeInfos={store.toJS().alertTypeInfos}
          />
        </div>
      )}
      {monthlySetting.isShowNoOfAlert && (
        <div className='w-full p-4 pt-1'>
          <ChartSummaryNoOfDayForEachAlertMonthly
            t={t}
            title={t('patient_summary_number_of_days_with_notifications')}
            dateRange={dateRange}
            summaryAlertMonthlyData={store.toJS().summaryAlertMonthly}
            alertTypeInfos={store.toJS().alertTypeInfos}
          />
        </div>
      )}
      {monthlySetting.isShowAvgAlertPerDay && (
        <div className='w-full p-4 pt-1'>
          <ChartSummaryAlertAvgMonthly
            t={t}
            title={t('patient_summary_average_number_of_notifications_per_day')}
            dateRange={dateRange}
            summaryAlertMonthlyData={store.toJS().summaryAlertMonthly}
            alertTypeInfos={store.toJS().alertTypeInfos}
          />
        </div>
      )}
    </div>
  );
};

const PatientSummaryAlertTopControlPanel = (props) => {
  const t = props.t;
  const chartType = props.chartType;
  const onChartTypeChanged = props.onChartTypeChanged;
  const dateRange = props.dateRange;
  const onStartDateChange = props.onStartDateChange;
  const onEndDateChange = props.onEndDateChange;
  const onMonthlySettingChange = props.onMonthlySettingChange;
  const onDailySettingChange = props.onDailySettingChange;
  const onIsShowTableChangedForMonthly = props.onIsShowTableChangedForMonthly;
  const monthlySetting = props.monthlySetting;
  const dailySetting = props.dailySetting;
  const onDownloadCsv = props.onDownloadCsv;

  let subControl = <></>;
  let chartOrTableToggle = <></>;
  if (chartType === 'monthly') {
    const checkboxInfos = [
      {
        value: 'isShowAlert',
        title: t('patient_summary_total_number_of_notifications'),
        checked: monthlySetting['isShowAlert'],
      },
      {
        value: 'isShowNoOfAlert',
        title: t('patient_summary_number_of_days_with_notifications'),
        checked: monthlySetting['isShowNoOfAlert'],
      },
      {
        value: 'isShowAvgAlertPerDay',
        title: t('patient_summary_average_number_of_notifications_per_day'),
        checked: monthlySetting['isShowAvgAlertPerDay'],
      },
    ];
    subControl = (
      <PatientSummaryAlertSelectReportType
        checkboxInfos={checkboxInfos}
        onCheckboxChange={onMonthlySettingChange}
      ></PatientSummaryAlertSelectReportType>
    );
    chartOrTableToggle = (
      <div className='align-items: flex-end;'>
        <ButtonBarChartOrTable
          isShowTableView={monthlySetting.isShowTableView}
          onIsShowTableChanged={onIsShowTableChangedForMonthly}
        />
      </div>
    );
  } else if (chartType === 'daily') {
    const checkboxInfos = [
      {
        value: 'isShowAlert',
        title: t('patient_summary_total_number_of_notifications'),
        checked: dailySetting['isShowAlert'],
      },
      { value: 'isShowUsage', title: t('patient_summary_total_usage_time'), checked: dailySetting['isShowUsage'] },
    ];
    subControl = (
      <PatientSummaryAlertSelectReportType
        checkboxInfos={checkboxInfos}
        onCheckboxChange={onDailySettingChange}
      ></PatientSummaryAlertSelectReportType>
    );
  }

  const onBtnCsvClick = (e) => {
    onDownloadCsv();
  };

  return (
    <>
      <div className='block col-span-12 px-1 pt-4 lg:flex md:flex'>
        <ButtonBarForPatientSummary t={t} chartType={chartType} onChartTypeChanged={onChartTypeChanged} />
        <div className='block pl-16'>
          <CalendarDateRange
            startDate={dateRange.startDate}
            endDate={dateRange.endDate}
            onStartDateChange={onStartDateChange}
            onEndDateChange={onEndDateChange}
          />
        </div>
        {chartOrTableToggle}
        <div className='block pl-16'>
          <button
            onClick={onBtnCsvClick}
            className='flex items-center justify-center w-30 h-9 text-lg font-normal tracking-wide text-center no-underline capitalize border border-green-gray hover:text-summary-header text-summary-header rounded-l rounded-r'
          >
            <svg className='fill-current w-4 h-4 mr-2' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'>
              <path d='M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z' />
            </svg>
            <span>CSV</span>
          </button>
        </div>
      </div>
      <div className='px-6'>
        <div className='flex-wrap block xl:flex'>
          <div className='w-full p-4 pt-1 xl:w-3/3'>
            <div className='flex flex-wrap flex-grow col-span-12 my-1'>{subControl}</div>
          </div>
        </div>
      </div>
    </>
  );
};

const PatientSummaryAlertSelectReportType = (props) => {
  const onCheckboxChange = props.onCheckboxChange;
  const checkboxInfos = props.checkboxInfos;
  const checkboxs = checkboxInfos.map((info) => {
    return (
      <FormControlLabel
        key={info.value}
        label={info.title}
        control={
          <Checkbox
            checked={info.checked}
            onChange={(e) => {
              onCheckboxChange(info.value, e.target.checked);
            }}
          />
        }
      ></FormControlLabel>
    );
  });

  return <FormGroup row>{checkboxs}</FormGroup>;
};

const ChartSummaryAlertDailyAllMonths = (props) => {
  const dateRange = props.dateRange;
  const summaryAlertDailyData = props.summaryAlertDailyData;
  const alertTypeInfos = props.alertTypeInfos;
  const t = props.t;

  const months = [];
  let monthsIndex = -1;
  let currMonth = '';
  const currDate = new Date(dateRange.startDate.getTime());

  while (currDate.getTime() < dateRange.endDate) {
    const month = dateToMonthStirng(currDate);
    if (month !== currMonth) {
      monthsIndex++;
      currMonth = month;
    }
    if (!months[monthsIndex]) {
      months[monthsIndex] = {
        startDate: new Date(currDate.getTime()),
        endDate: null,
      };
    } else {
      months[monthsIndex].endDate = new Date(currDate.getTime());
    }
    currDate.setDate(currDate.getDate() + 1);
  }

  const charts = [];
  let i = 0;
  months.forEach((dateRange) => {
    const title = dateToMonthStirngDisplay(t, dateRange.startDate);
    const chart = (
      <div key={`chart-${i}`}>
        <ChartSummaryAlertDaily
          t={t}
          title={title}
          dateRange={dateRange}
          summaryAlertDailyData={summaryAlertDailyData}
          alertTypeInfos={alertTypeInfos}
        />
      </div>
    );
    charts.push(chart);
    i++;
  });

  return <div className='grid gap-y-16 grid-cols-3'>{charts}</div>;
};

const ChartSummaryUsageDaily = (props) => {
  const dateRange = props.dateRange;
  const summaryUsageData = props.summaryUsageData;
  const title = props.title ?? '';
  const t = props.t;
  let subtitle = '';
  if (props.title) {
    subtitle = getSubTitle(t, dateRange);
  }

  const datas = summaryUsageData.datas;
  if (!datas) {
    return <></>;
  }
  const dates = getDateRange(dateRange);
  const totals = [];
  for (let date of dates) {
    const dataFiltered = datas.filter((data) => {
      return data.date === date;
    });
    if (dataFiltered.length === 0) {
      totals.push(0);
      continue;
    }
    totals.push(dataFiltered[0].duration.total);
  }

  const series = {
    name: `เวลารวม`,
    data: totals,
  };

  const categories = [];
  for (let i = 0; i <= 24; i++) {
    categories.push(i * 3600);
  }

  const chart = {
    yAxis: {
      tickPositioner: function () {
        return categories;
      },
      title: {
        text: `${t('patient_summary_usage_time')} (${t('hour')})`,
      },
      labels: {
        formatter: function () {
          return `${this.value / 3600}`;
        },
      },
    },
    xAxis: {
      categories: dates,
    },
    title: {
      text: title,
    },
    subtitle: {
      text: subtitle,
    },
    series: [series],
  };

  return (
    <Typography component='div'>
      <HighchartsReact
        highcharts={Highcharts}
        options={chart}
        // callback={this.props.dataChartHRVsTemp}
      />
    </Typography>
  );
};

const ChartSummaryAlertDaily = (props) => {
  const dateRange = props.dateRange;
  const summaryAlertDailyData = props.summaryAlertDailyData;
  //const alertTypeInfos = props.alertTypeInfos;
  const title = props.title ?? '';
  let subtitle = '';
  const t = props.t;
  if (props.title) {
    subtitle = getSubTitle(t, dateRange);
  }

  const initSeriesDatas = (datas) => {
    const seriesDatas = new Map();
    for (let data of datas) {
      for (let alertType in data.alerts) {
        if (!seriesDatas.has(alertType)) {
          seriesDatas.set(alertType, []);
        }
      }
    }
    return seriesDatas;
  };

  const fillinDataToSeriesDatas = (dates, datas) => {
    const seriesDatas = initSeriesDatas(datas);
    for (let date of dates) {
      const dataFiltered = datas.filter((data) => {
        return data.date === date;
      });
      if (dataFiltered.length === 0) {
        pushOneValueToAll(seriesDatas, 0);
        continue;
      }
      const alerts = dataFiltered[0].alerts;
      pushByAlertType(seriesDatas, alerts);
    }
    return seriesDatas;
  };

  const datas = summaryAlertDailyData.datas;
  const dates = getDateRange(dateRange);
  const seriesDatas = fillinDataToSeriesDatas(dates, datas);

  const series = [];
  //let maxData = 0;
  for (let [alertType, value] of seriesDatas) {
    //const max = Math.max(...value);
    //if (max > maxData) {
    //  maxData = max;
    //}
    series.push({
      name: `${getAlertTypeName(t, alertType)}`,
      data: value,
    });
  }
  //TODO: แก้ text
  const chart = {
    chart: {
      events: {
        load: function () {
          //if (maxData <= 0) {
          //this.yAxis[0].setExtremes(0, 1);
          //}
        },
      },
    },
    yAxis: [
      {
        title: {
          text: t('patient_summary_number_of_notifications_y'),
        },
      },
    ],
    xAxis: {
      categories: dates,
    },
    title: {
      text: title,
    },
    subtitle: {
      text: subtitle,
    },
    series: series,
  };

  return (
    <Typography component='div'>
      <HighchartsReact
        highcharts={Highcharts}
        options={chart}
        // callback={this.props.dataChartHRVsTemp}
      />
    </Typography>
  );
};

const tableSummaryStyle = (theme) => ({
  table: {
    fontFamily: theme.typography.fontFamily,
  },
  flexContainer: {
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
  },
  tableRow: {
    cursor: 'pointer',
  },
  tableRowHover: {
    '&:hover': {
      backgroundColor: theme.palette.grey[200],
    },
  },
  tableCell: {
    flex: 1,
  },
  noClick: {
    cursor: 'initial',
  },
});

const TableSummaryNoOfDayForEachAlertMonthly = (props) => {
  const dateRange = props.dateRange;
  const summaryAlertMonthlyData = props.summaryAlertMonthlyData;
  //const alertTypeInfos = props.alertTypeInfos;
  const title = props.title ?? '';
  let subtitle = '';
  const t = props.t;
  if (props.title) {
    subtitle = getSubTitle(t, dateRange);
  }
  if (!summaryAlertMonthlyData.datas) {
    return <></>;
  }

  const getRowClassName = ({ index }) => {
    const { classes, rowClassName, onRowClick } = props;
    return classNames(classes.tableRow, classes.flexContainer, rowClassName, {
      [classes.tableRowHover]: index !== -1 && onRowClick != null,
    });
  };

  const alertTypes = getAllAlertType(summaryAlertMonthlyData.datas);
  const cols = [];
  cols.push({ label: t('month'), dataKey: 'month', width: 100, flexGrow: 1.0 });
  for (let [alertType] of alertTypes) {
    cols.push({ label: getAlertTypeName(t, alertType), dataKey: alertType, width: 100, flexGrow: 1.0 });
  }

  const cellRenderer = ({ cellData, columnIndex = null }) => {
    return (
      <TableCell component='div' variant='body'>
        {cellData}
      </TableCell>
    );
  };

  const headerRenderer = ({ label, columnIndex, dataKey, sortBy, sortDirection }) => {
    console.log(label);
    const inner = label;
    return (
      <TableCell component='div' variant='head' style={{ height: 30 }}>
        {inner}
      </TableCell>
    );
  };

  const datas = summaryAlertMonthlyData.datas;
  const rows = [];
  for (let data of datas) {
    var row = { month: data.month };
    for (let [alertType] of alertTypes) {
      const val = data.noOfDayForEachAlert[alertType];
      if (val) {
        row[alertType] = val;
      } else {
        row[alertType] = 0;
      }
    }
    rows.push(row);
  }

  return (
    <Paper elevation={0} style={{ height: 400, width: '100%' }}>
      <TableTitle title={title} subtitle={subtitle}></TableTitle>
      <AutoSizer>
        {({ height, width }) => (
          <Table
            headerHeight={56}
            rowClassName={getRowClassName}
            rowHeight={30}
            rowCount={rows.length}
            rowGetter={({ index }) => rows[index]}
            height={height}
            width={width}
          >
            {cols.map(({ cellContentRenderer = null, className, dataKey, ...other }, index) => {
              return (
                <Column
                  key={dataKey}
                  dataKey={dataKey}
                  cellRenderer={cellRenderer}
                  headerRenderer={(headerProps) => {
                    return headerRenderer({
                      ...headerProps,
                      columnIndex: index,
                    });
                  }}
                  {...other}
                ></Column>
              );
            })}
          </Table>
        )}
      </AutoSizer>
    </Paper>
  );
};

const TableTitle = (props) => {
  return (
    <div class='py-8'>
      <div class='flex justify-center ...'>
        <p class='font-bold'>{props.title}</p>
      </div>
      <div class='flex justify-center ...'> {props.subtitle}</div>
    </div>
  );
};

const getAllAlertType = (datas) => {
  const alertTypesAll = new Map();
  for (let data of datas) {
    for (let alertType in data.alerts) {
      if (!alertTypesAll.has(alertType)) {
        alertTypesAll.set(alertType);
      }
    }
  }
  return alertTypesAll;
};

const TableSummaryAlertAvgMonthly = (props) => {
  const dateRange = props.dateRange;
  const summaryAlertMonthlyData = props.summaryAlertMonthlyData;
  //const alertTypeInfos = props.alertTypeInfos;
  const title = props.title ?? '';
  let subtitle = '';
  const t = props.t;
  if (props.title) {
    subtitle = getSubTitle(t, dateRange);
  }

  if (!summaryAlertMonthlyData.datas) {
    return <></>;
  }

  const getRowClassName = ({ index }) => {
    const { classes, rowClassName, onRowClick } = props;
    return classNames(classes.tableRow, classes.flexContainer, rowClassName, {
      [classes.tableRowHover]: index !== -1 && onRowClick != null,
    });
  };

  const alertTypes = getAllAlertType(summaryAlertMonthlyData.datas);
  const cols = [];
  cols.push({ label: t('month'), dataKey: 'month', width: 100, flexGrow: 1.0 });
  for (let [alertType] of alertTypes) {
    cols.push({ label: getAlertTypeName(t, alertType), dataKey: alertType, width: 100, flexGrow: 1.0 });
  }

  const cellRenderer = ({ cellData, columnIndex = null }) => {
    return (
      <TableCell component='div' variant='body'>
        {cellData}
      </TableCell>
    );
  };

  const headerRenderer = ({ label, columnIndex, dataKey, sortBy, sortDirection }) => {
    const inner = label;
    return (
      <TableCell component='div' variant='head' style={{ height: 30 }}>
        {inner}
      </TableCell>
    );
  };

  const datas = summaryAlertMonthlyData.datas;
  const rows = [];
  for (let data of datas) {
    var row = { month: data.month };
    for (let [alertType] of alertTypes) {
      const val = data.alertAvgsPerDay[alertType];
      if (val) {
        row[alertType] = val;
      } else {
        row[alertType] = 0;
      }
    }
    rows.push(row);
  }

  return (
    <Paper elevation={0} style={{ height: 400, width: '100%' }}>
      <TableTitle title={title} subtitle={subtitle}></TableTitle>
      <AutoSizer>
        {({ height, width }) => (
          <Table
            headerHeight={56}
            rowClassName={getRowClassName}
            rowHeight={30}
            rowCount={rows.length}
            rowGetter={({ index }) => rows[index]}
            height={height}
            width={width}
          >
            {cols.map(({ cellContentRenderer = null, className, dataKey, ...other }, index) => {
              return (
                <Column
                  key={dataKey}
                  dataKey={dataKey}
                  cellRenderer={cellRenderer}
                  headerRenderer={(headerProps) => {
                    return headerRenderer({
                      ...headerProps,
                      columnIndex: index,
                    });
                  }}
                  {...other}
                ></Column>
              );
            })}
          </Table>
        )}
      </AutoSizer>
    </Paper>
  );
};

const TableSummaryAlertMonthly = (props) => {
  const dateRange = props.dateRange;
  const summaryAlertMonthlyData = props.summaryAlertMonthlyData;
  //const alertTypeInfos = props.alertTypeInfos;
  const title = props.title ?? '';
  let subtitle = '';
  const t = props.t;
  if (props.title) {
    subtitle = getSubTitle(t, dateRange);
  }

  if (!summaryAlertMonthlyData.datas) {
    return <></>;
  }

  const getRowClassName = ({ index }) => {
    const { classes, rowClassName, onRowClick } = props;
    return classNames(classes.tableRow, classes.flexContainer, rowClassName, {
      [classes.tableRowHover]: index !== -1 && onRowClick != null,
    });
  };

  const alertTypes = getAllAlertType(summaryAlertMonthlyData.datas);
  const cols = [];
  cols.push({ label: t('month'), dataKey: 'month', width: 100, flexGrow: 1.0 });
  for (let [alertType] of alertTypes) {
    cols.push({ label: getAlertTypeName(t, alertType), dataKey: alertType, width: 100, flexGrow: 1.0 });
  }

  const cellRenderer = ({ cellData, columnIndex = null }) => {
    return (
      <TableCell component='div' variant='body'>
        {cellData}
      </TableCell>
    );
  };

  const headerRenderer = ({ label, columnIndex, dataKey, sortBy, sortDirection }) => {
    const inner = label;
    return (
      <TableCell component='div' variant='head' style={{ height: 30 }}>
        {inner}
      </TableCell>
    );
  };

  const datas = summaryAlertMonthlyData.datas;
  const rows = [];
  for (let data of datas) {
    var row = { month: data.month };
    for (let [alertType] of alertTypes) {
      const val = data.alerts[alertType];
      if (val) {
        row[alertType] = val;
      } else {
        row[alertType] = 0;
      }
    }
    rows.push(row);
  }

  //const headerSort = ({ sortBy, sortDirection }) => {
  //  alert('xxxx');
  //  debugger;
  //}

  return (
    <Paper elevation={0} style={{ height: 400, width: '100%' }}>
      <TableTitle title={title} subtitle={subtitle}></TableTitle>
      <AutoSizer>
        {({ height, width }) => (
          <Table
            headerHeight={56}
            rowClassName={getRowClassName}
            rowHeight={30}
            rowCount={rows.length}
            rowGetter={({ index }) => rows[index]}
            height={height}
            width={width}
          >
            {cols.map(({ cellContentRenderer = null, className, dataKey, ...other }, index) => {
              return (
                <Column
                  key={dataKey}
                  dataKey={dataKey}
                  cellRenderer={cellRenderer}
                  headerRenderer={(headerProps) => {
                    return headerRenderer({
                      ...headerProps,
                      columnIndex: index,
                    });
                  }}
                  {...other}
                ></Column>
              );
            })}
          </Table>
        )}
      </AutoSizer>
    </Paper>
  );
};

const WrappedTableSummaryAlertMonthly = withStyles(tableSummaryStyle)(TableSummaryAlertMonthly);
const WrappedTableSummaryNoOfDayForEachAlertMonthly = withStyles(tableSummaryStyle)(
  TableSummaryNoOfDayForEachAlertMonthly,
);
const WrappedTableSummaryAlertAvgMonthly = withStyles(tableSummaryStyle)(TableSummaryAlertAvgMonthly);

const ChartSummaryAlertMonthly = (props) => {
  const dateRange = props.dateRange;
  const summaryAlertMonthlyData = props.summaryAlertMonthlyData;
  //const alertTypeInfos = props.alertTypeInfos;
  const title = props.title ?? '';
  let subtitle = '';
  const t = props.t;
  if (props.title) {
    subtitle = getSubTitle(t, dateRange);
  }

  if (!summaryAlertMonthlyData.datas) {
    return <></>;
  }

  const initSeriesDatas = (datas) => {
    const seriesDatas = new Map();
    for (let data of datas) {
      for (let alertType in data.alerts) {
        if (!seriesDatas.has(alertType)) {
          seriesDatas.set(alertType, []);
        }
      }
    }
    return seriesDatas;
  };

  const fillinDataToSeriesDatas = (months, datas) => {
    const seriesDatas = initSeriesDatas(datas);
    for (let month of months) {
      const dataFiltered = datas.filter((data) => {
        return data.month === month;
      });
      if (dataFiltered.length === 0) {
        pushOneValueToAll(seriesDatas, 0);
        continue;
      }
      const alerts = dataFiltered[0].alerts;
      pushByAlertType(seriesDatas, alerts);
    }
    return seriesDatas;
  };

  const datas = summaryAlertMonthlyData.datas;
  const months = getMonthRange(dateRange);
  const seriesDatas = fillinDataToSeriesDatas(months, datas);

  const series = [];
  for (let [alertType, value] of seriesDatas) {
    series.push({
      name: `${getAlertTypeName(t, alertType)}`,
      data: value,
    });
  }
  const chart = {
    yAxis: [
      {
        title: {
          text: t('patient_summary_number_of_notifications_y'),
        },
      },
    ],
    xAxis: {
      categories: months,
    },
    title: {
      text: title,
    },
    subtitle: {
      text: subtitle,
    },
    series: series,
  };

  return (
    <Typography component='div'>
      <HighchartsReact
        highcharts={Highcharts}
        options={chart}
        // callback={this.props.dataChartHRVsTemp}
      />
    </Typography>
  );
};

const ChartSummaryNoOfDayForEachAlertMonthly = (props) => {
  const dateRange = props.dateRange;
  const summaryAlertMonthlyData = props.summaryAlertMonthlyData;
  //const alertTypeInfos = props.alertTypeInfos;
  const title = props.title ?? '';
  let subtitle = '';
  const t = props.t;
  if (props.title) {
    subtitle = getSubTitle(t, dateRange);
  }
  if (!summaryAlertMonthlyData.datas) {
    return <></>;
  }

  const initSeriesDatas = (datas) => {
    const seriesDatas = new Map();
    for (let data of datas) {
      for (let alertType in data.noOfDayForEachAlert) {
        if (!seriesDatas.has(alertType)) {
          seriesDatas.set(alertType, []);
        }
      }
    }
    return seriesDatas;
  };

  const fillinDataToSeriesDatas = (months, datas) => {
    const seriesDatas = initSeriesDatas(datas);
    for (let month of months) {
      const dataFiltered = datas.filter((data) => {
        return data.month === month;
      });
      if (dataFiltered.length === 0) {
        pushOneValueToAll(seriesDatas, 0);
        continue;
      }
      const alerts = dataFiltered[0].noOfDayForEachAlert;
      pushByAlertType(seriesDatas, alerts);
    }
    return seriesDatas;
  };

  const datas = summaryAlertMonthlyData.datas;
  const months = getMonthRange(dateRange);
  const seriesDatas = fillinDataToSeriesDatas(months, datas);

  const series = [];
  for (let [alertType, value] of seriesDatas) {
    series.push({
      name: `${getAlertTypeName(t, alertType)}`,
      data: value,
    });
  }
  const chart = {
    yAxis: [
      {
        title: {
          text: t('patient_summary_number_of_days_with_notifications_y'),
        },
      },
    ],
    xAxis: {
      categories: months,
    },
    title: {
      text: title,
    },
    subtitle: {
      text: subtitle,
    },
    series: series,
  };

  return (
    <Typography component='div'>
      <HighchartsReact
        highcharts={Highcharts}
        options={chart}
        // callback={this.props.dataChartHRVsTemp}
      />
    </Typography>
  );
};

const ChartSummaryAlertAvgMonthly = (props) => {
  const dateRange = props.dateRange;
  const summaryAlertMonthlyData = props.summaryAlertMonthlyData;
  //const alertTypeInfos = props.alertTypeInfos;
  const title = props.title ?? '';
  let subtitle = '';
  const t = props.t;
  if (props.title) {
    subtitle = getSubTitle(t, dateRange);
  }
  if (!summaryAlertMonthlyData.datas) {
    return <></>;
  }
  if (!summaryAlertMonthlyData.datas) {
    return <></>;
  }

  const initSeriesDatas = (datas) => {
    const seriesDatas = new Map();
    for (let data of datas) {
      for (let alertType in data.alertAvgsPerDay) {
        if (!seriesDatas.has(alertType)) {
          seriesDatas.set(alertType, []);
        }
      }
    }
    return seriesDatas;
  };

  const fillinDataToSeriesDatas = (months, datas) => {
    const seriesDatas = initSeriesDatas(datas);
    for (let month of months) {
      const dataFiltered = datas.filter((data) => {
        return data.month === month;
      });
      if (dataFiltered.length === 0) {
        pushOneValueToAll(seriesDatas, 0);
        continue;
      }
      const alerts = dataFiltered[0].alertAvgsPerDay;
      pushByAlertType(seriesDatas, alerts);
    }
    return seriesDatas;
  };

  const datas = summaryAlertMonthlyData.datas;
  //debugger;
  const months = getMonthRange(dateRange);
  const seriesDatas = fillinDataToSeriesDatas(months, datas);

  const series = [];
  for (let [alertType, value] of seriesDatas) {
    series.push({
      name: `${getAlertTypeName(t, alertType)}`,
      data: value,
    });
  }

  const chart = {
    yAxis: [
      {
        title: {
          text: t('patient_summary_average_number_of_notifications_per_day_y'),
        },
      },
    ],
    xAxis: {
      categories: months,
    },
    title: {
      text: title,
    },
    subtitle: {
      text: subtitle,
    },
    series: series,
  };

  return (
    <Typography component='div'>
      <HighchartsReact
        highcharts={Highcharts}
        options={chart}
        // callback={this.props.dataChartHRVsTemp}
      />
    </Typography>
  );
};

const dateToMonthStirngDisplay = (t, date) => {
  //const monthsTh = ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม",];
  const monthsTh = [
    t('month_january'),
    t('month_february'),
    t('month_march'),
    t('month_april'),
    t('month_may'),
    t('month_june'),
    t('month_july'),
    t('month_august'),
    t('month_september'),
    t('month_october'),
    t('month_november'),
    t('month_december'),
  ];

  return `${monthsTh[date.getMonth()]} ${date.getFullYear()}`;
};

const dateToDateStringDisplay = (t, date) => {
  return ('0' + date.getDate()).slice(-2) + ' ' + dateToMonthStirngDisplay(t, date);
};

const dateToMonthStirng = (date) => {
  return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}`;
};

const dateToDateString = (date) => {
  return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
};

const getMonthRange = (dateRange) => {
  const currDate = new Date(dateRange.startDate.getTime());
  const months = [];
  while (currDate.getTime() < dateRange.endDate) {
    months.push(dateToMonthStirng(currDate));
    currDate.setMonth(currDate.getMonth() + 1);
  }
  return months;
};

const getDateRange = (dateRange) => {
  const currDate = new Date(dateRange.startDate.getTime());
  const dates = [];
  while (currDate.getTime() <= dateRange.endDate) {
    dates.push(dateToDateString(currDate));
    currDate.setDate(currDate.getDate() + 1);
  }
  return dates;
};

const pushOneValueToAll = (seriesDatas, value) => {
  for (var [key] of seriesDatas) {
    seriesDatas.get(key).push(value);
  }
};

const pushByAlertType = (seriesDatas, alerts) => {
  for (var [key] of seriesDatas) {
    if (alerts[key] === undefined) {
      seriesDatas.get(key).push(0);
    } else {
      seriesDatas.get(key).push(alerts[key]);
    }
  }
};

/*
const getAlertTypeName = (alertTypeInfos, alertType) => {
  for (let id in alertTypeInfos) {
    if (id === alertType) {
      return `${alertTypeInfos[id].name}`
    }
  }
  return `${alertType}`;
}
*/

const getSubTitle = (t, dateRange) => {
  if (dateRange.endDate) {
    return `${t('patient_summary_data_from_date')} ${dateToDateStringDisplay(t, dateRange.startDate)} ${t('patient_summary_data_to_date')} ${dateToDateStringDisplay(t, dateRange.endDate)}`;
  }
  return `${t('patient_summary_data_at_date')} ${dateToDateStringDisplay(t, dateRange.startDate)}`;
};

const getAlertTypeName = (t, v) => {
  const value = parseInt(v, 10);
  let result = `${t('unknown')}`;
  switch (value) {
    case 1:
      result = `${t('lying')}`;
      break;
    case 2:
      result = `${t('sitting')}`;
      break;
    case 3:
      result = `${t('standing')}`;
      break;
    case 4:
      result = `${t('walking')}`;
      break;
    case 5:
      result = `${t('Running')}`;
      break;
    case 6:
      result = `${t('Jumping')}`;
      break;
    case 7:
      result = `${t('lying_on_back')}`;
      break;
    case 8:
      result = `${t('lying_on_stomach')}`;
      break;
    case 9:
      result = `${t('lying_on_left_side')}`;
      break;
    case 10:
      result = `${t('lying_on_right_side')}`;
      break;
    case 501:
      result = `${t('get_up')}`;
      break;
    case 502:
      result = `${t('movement')}`;
      break;
    case 503:
      result = `${t('low_battery')}`;
      break;
    case 504:
      result = `${t('no_signal')}`;
      break;
    case 505:
      result = `${t('alert_router_no_signal')}`;
      break;
    case 506:
      result = `${t('alert_not_turn')}`;
      break;
    case 507:
      result = `${t('alert_no_movement')}`;
      break;
    case 508:
      result = `${t('alert_fall')}`;
      break;
    case 509:
      result = `${t('out_of_area')}`;
      break;
    case 510:
      result = `${t('in_to_area')}`;
      break;
    case 511:
      result = `${t('alert_walking')}`;
      break;
    case 512:
      result = `${t('alert_deactivate_recharge')}`;
      break;
    case 513:
      result = `${t('alert_bad_signal')}`;
      break;
    case 514:
      result = `${t('alert_emergency_alarm')}`;
      break;
    default:
      break;
  }
  return result;
};

//export const page = inject("patientsummaryalert")(observer(PatientSummaryAlert));
//export const translation = withTranslation()(page);
//export default withStyles(styles, { withTheme: true })(translation);

//export default PatientSummaryAlert;
export default inject('patientsummaryalert')(observer((props) => PatientSummaryAlert(props)));
